export enum DateFilterId {
  CUSTOM = "custom",
  ALL = "all",
  LAST_DAY = "lastDay",
  LAST_WEEK = "lastWeek",
  LAST_MONTH = "lastMonth",
  LAST_3_MONTHS = "last3Months",
  LAST_6_MONTHS = "last6Months",
  LAST_YEAR = "lastYear",
}
